import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function ToolAccessGuardError() {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    "data-test-id": "tool-access-guard-error",
    illustration: "errors/general",
    title: /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.defaultTitle"
      })
    }),
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.error.buttonBody"
      })
    })
  });
}
ToolAccessGuardError.propTypes = {};
export default ToolAccessGuardError;